import type { ReactNode } from 'react';
import { Anchor, Group } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

/** Props for {@link BackLink}. */
export interface BackLinkProps {
  /** Destination route the link navigates to (e.g. "/settings"). */
  to: string;
  /** Link text rendered after the back-arrow (e.g. "Settings"). */
  children: ReactNode;
}

/**
 * BackLink — a small dimmed "← {label}" navigation link placed at the top of a
 * sub-page so the user can return to its parent index (e.g. a settings detail
 * page returning to the Settings hub).
 *
 * Shell: any. Renders a React Router `<Link>` styled as a dimmed `Anchor` with a
 * leading back-arrow icon. `alignSelf: flex-start` keeps the click target tight
 * when it is a direct child of a stretch-aligned `<Stack>`.
 */
export function BackLink({ to, children }: BackLinkProps) {
  return (
    <Anchor component={Link} to={to} size="sm" c="dimmed" style={{ alignSelf: 'flex-start' }}>
      <Group gap={4} wrap="nowrap">
        <IconArrowLeft size={14} />
        {children}
      </Group>
    </Anchor>
  );
}
